import { render, staticRenderFns } from "./versionHeader.vue?vue&type=template&id=61d7b0af&scoped=true&"
import script from "./versionHeader.vue?vue&type=script&lang=js&"
export * from "./versionHeader.vue?vue&type=script&lang=js&"
import style0 from "./versionHeader.vue?vue&type=style&index=0&id=61d7b0af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d7b0af",
  null
  
)

export default component.exports